import { useFormikContext } from "formik";
import { useMemo } from "react";
import { useActionChoices } from "stores";
import { checkIfEmpty } from "utils/utils";

const findAvailableTaskOptions = (selectedTypeId, actions) => {
  if (checkIfEmpty(actions)) return [];
  if (selectedTypeId?.toString() === "1") {
    return [
      actions.watering,
      actions.drug,
      actions.fertilize,
      actions.diagnose,
      actions.other,
      actions.observation,
    ];
  } else {
    return [actions.watering, actions.drug, actions.fertilize, actions.other];
  }
};

export const useTaskOptions = () => {
  const { values } = useFormikContext();
  const { actions } = useActionChoices();

  const availableTaskOptions = useMemo(() => {
    const availableTasks = findAvailableTaskOptions(
      values?.actionTypeId,
      actions,
    );
    return availableTasks?.map(({ taskId, taskName }) => ({
      value: taskId,
      label: taskName,
    }));
  }, [actions, values?.actionTypeId]);

  return availableTaskOptions;
};
